import type { SVGProps } from 'react';

export const GetLostLogoIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="1200" height="852" viewBox="0 0 1200 852" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_41_631)">
                <mask
                    id="mask0_41_631"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="1200"
                    height="852"
                >
                    <path
                        d="M1090.86 824.635C1011.26 863.321 915.427 860.228 794.746 820.172C644.226 764.971 609.69 750.117 529.761 728.282C475.839 713.554 366.113 692.935 247.53 715.372C247.53 715.372 182.836 728.985 128.914 749.799C95.2808 762.967 62.9532 779.262 32.355 798.47C32.355 798.47 8.6844 735.238 2.19614 650.364C-4.26074 583.764 4.90191 530.042 11.8725 486.38C32.2647 363.109 109.163 248.016 144.238 212.745C180.812 169.122 227.305 124.208 310.472 75.7049C383.662 32.8657 498.264 -1.18773 598.641 0.0317591C706.865 2.51983 779.485 18.5519 880.789 69.0752C947.429 102.691 1006.79 149.153 1055.46 205.795C1068.63 220.916 1077.05 232.125 1077.05 232.125L1097.76 259.763C1097.76 259.763 1142.58 325.06 1165.16 389.217C1174.33 412.728 1181.82 436.866 1187.55 461.446C1209.95 554.237 1201.91 684.506 1165.16 745.828C1136.95 799.012 1094.83 822.625 1090.86 824.635Z"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask0_41_631)">
                    <path
                        d="M602.231 1206.26C934.82 1206.26 1204.44 936.235 1204.44 603.144C1204.44 270.053 934.82 0.0299377 602.231 0.0299377C269.642 0.0299377 0.0251465 270.053 0.0251465 603.144C0.0251465 936.235 269.642 1206.26 602.231 1206.26Z"
                        fill="#007375"
                    />
                </g>
                <mask
                    id="mask1_41_631"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="1200"
                    height="852"
                >
                    <path
                        d="M1090.86 824.635C1011.26 863.321 915.427 860.228 794.746 820.172C644.226 764.971 609.69 750.117 529.761 728.282C475.839 713.554 366.113 692.935 247.53 715.372C247.53 715.372 182.836 728.985 128.914 749.799C95.2808 762.967 62.9532 779.262 32.355 798.47C32.355 798.47 8.6844 735.238 2.19614 650.364C-4.26074 583.764 4.90191 530.042 11.8725 486.38C32.2647 363.109 109.163 248.016 144.238 212.745C180.812 169.122 227.305 124.208 310.472 75.7049C383.662 32.8657 498.264 -1.18773 598.641 0.0317591C706.865 2.51983 779.485 18.5519 880.789 69.0752C947.429 102.691 1006.79 149.153 1055.46 205.795C1068.63 220.916 1077.05 232.125 1077.05 232.125L1097.76 259.763C1097.76 259.763 1142.58 325.06 1165.16 389.217C1174.33 412.728 1181.82 436.866 1187.55 461.446C1209.95 554.237 1201.91 684.506 1165.16 745.828C1136.95 799.012 1094.83 822.625 1090.86 824.635Z"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask1_41_631)">
                    <path
                        d="M695.91 1112.45C947.201 1112.45 1150.91 908.428 1150.91 656.759C1150.91 405.089 947.201 201.071 695.91 201.071C444.62 201.071 240.909 405.089 240.909 656.759C240.909 908.428 444.62 1112.45 695.91 1112.45Z"
                        fill="#00A39B"
                    />
                </g>
                <mask
                    id="mask2_41_631"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="1200"
                    height="852"
                >
                    <path
                        d="M1090.86 824.635C1011.26 863.321 915.427 860.228 794.746 820.172C644.226 764.971 609.69 750.117 529.761 728.282C475.839 713.554 366.113 692.935 247.53 715.372C247.53 715.372 182.836 728.985 128.914 749.799C95.2808 762.967 62.9532 779.262 32.355 798.47C32.355 798.47 8.6844 735.238 2.19614 650.364C-4.26074 583.764 4.90191 530.042 11.8725 486.38C32.2647 363.109 109.163 248.016 144.238 212.745C180.812 169.122 227.305 124.208 310.472 75.7049C383.662 32.8657 498.264 -1.18773 598.641 0.0317591C706.865 2.51983 779.485 18.5519 880.789 69.0752C947.429 102.691 1006.79 149.153 1055.46 205.795C1068.63 220.916 1077.05 232.125 1077.05 232.125L1097.76 259.763C1097.76 259.763 1142.58 325.06 1165.16 389.217C1174.33 412.728 1181.82 436.866 1187.55 461.446C1209.95 554.237 1201.91 684.506 1165.16 745.828C1136.95 799.012 1094.83 822.625 1090.86 824.635Z"
                        fill="#D9D9D9"
                    />
                </mask>
                <g mask="url(#mask2_41_631)">
                    <path
                        d="M818.03 425.562C875.929 425.562 932.529 442.757 980.671 474.973C1028.81 507.189 1066.33 552.979 1088.49 606.552C1110.65 660.125 1116.45 719.075 1105.15 775.948C1093.85 832.821 1065.97 885.062 1025.03 926.065C984.091 967.068 931.929 994.991 875.142 1006.3C818.354 1017.62 759.493 1011.81 706.001 989.62C652.508 967.429 606.787 929.85 574.62 881.636C542.453 833.422 525.284 776.737 525.284 718.75C525.284 640.991 556.126 566.418 611.027 511.435C665.927 456.451 740.389 425.562 818.03 425.562Z"
                        fill="#E5E5E5"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_41_631">
                    <rect width="1200" height="852" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
